// FIXME: prevent invalid language codes(conflict with Intl).
export function switchWeglotLang(locale) {
  const env = process.env.NODE_ENV;
  if (env !== "test" && window.Weglot?.initialized) {
    let languageCode = locale;

    if (locale === "fil") {
      languageCode = "tl";
    }

    if (locale === "ak") {
      languageCode = "tw";
    }

    window.Weglot?.switchTo(languageCode);
  }
}

export function getWeglotLangs() {
  const env = process.env.NODE_ENV;

  if (env === "test" || !window.Weglot?.initialized) {
    return undefined;
  }

  // Weglot lets you add custom languages via its dashboard,
  // and Traditional Chinese appears to be one. Its language_to value is "a0"
  // (perhaps a placeholder?), while custom_code holds the proper ISO 639-1 code.
  // So use custom_code when defined, default to language_to otherwise.
  const languageOptions = window.Weglot.options.languages.map(
    (lang) => lang.custom_code ?? lang.language_to,
  );

  return ["en", ...languageOptions];
}

export function getWeglotLangName(locale) {
  const env = process.env.NODE_ENV;

  if (env !== "test" && window.Weglot?.initialized) {
    return window.Weglot?.getLanguageName(locale);
  }

  return undefined;
}
